import React from 'react';
import { useHistory } from 'react-router';

import BoxContainer from 'components/BoxContainer';
import Listagem, { IRow } from 'components/Listagem';

import { Container, TitleHolder, ListHolder } from '../styles';

const Departamentos: React.FC = () => {
  const history = useHistory();

  const rows: IRow[] = [
    {
      label: '#',
      data: 'id',
    },
    {
      label: 'Nome',
      data: 'nome',
    },
    {
      label: 'Cor',
      data: 'cor',
    },
  ];

  return (
    <Container>
      <TitleHolder>
        Departamentos:
        <button
          type="button"
          onClick={() => history.push('/cadastros/departamentos/novo')}
        >
          Novo departamento
        </button>
      </TitleHolder>
      <ListHolder>
        <BoxContainer borderColor="quaternary">
          <Listagem
            rows={rows}
            module="departamentos"
            template="100px 4fr 3fr"
            editUrl="/cadastros/departamentos/departamento"
            indexUrl="/cadastros/departamentos/departamento"
            deleteUrl="/departamentos/departamento"
          />
          {/* <PaginationHolder>
            div.
          </PaginationHolder> */}
        </BoxContainer>
      </ListHolder>
    </Container>
  );
};

export default Departamentos;
